import { useState } from 'react';
import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const faqItems = [
  {
    q: 'Как быстро приходят выплаты?',
    a: 'Сразу после того, как приведённый вами клиент оплачивает продукт. Никаких задержек, ожиданий конца месяца или накопления минимальной суммы. Деньги поступают напрямую.',
  },
  {
    q: 'Как отслеживать приведённых клиентов?',
    a: 'У каждого партнёра — персональная ссылка. Все переходы и покупки по ней фиксируются. Вы видите статус каждого клиента, сумму оплаты и начисленную комиссию в реальном времени.',
  },
  {
    q: 'Есть ли минимальный порог для вывода?',
    a: 'Нет. Выплачиваем любую сумму — хоть 500 ₽, хоть 50 000 ₽. Никаких «накопите 10 000 рублей, и тогда заплатим».',
  },
  {
    q: 'Какие продукты участвуют в партнёрской программе?',
    a: 'Все продукты AIGAM: Telegram заявки, AI рассыльщик, Перехват конкурентов, Интеграции, Заявки под ключ и Рассылка под ключ. Комиссия от 25% до 30% в зависимости от продукта.',
  },
  {
    q: 'Нужно ли разбираться в продукте, чтобы рекомендовать?',
    a: 'Мы предоставляем все материалы: готовые тексты, баннеры, презентации и кейсы. Вы можете просто делиться ссылкой с теми, кому это актуально. Но если захотите разобраться глубже — проведём демо и ответим на все вопросы.',
  },
  {
    q: 'Как заключить партнёрский договор?',
    a: 'Напишите нам в Telegram — @anna_aigam. Обсудим условия, подпишем договор и выдадим партнёрскую ссылку. Работаем с физлицами, ИП и юрлицами.',
  },
  {
    q: 'Можно ли совмещать с другой деятельностью?',
    a: 'Да, партнёрская программа не требует эксклюзивности. Вы можете параллельно вести любой бизнес, работать в найме или участвовать в других партнёрских программах.',
  },
  {
    q: 'Что если клиент вернёт деньги?',
    a: 'Если клиент оформляет возврат — комиссия по этому платежу аннулируется. Такое случается редко (менее 3% случаев), но мы честно предупреждаем об этом заранее.',
  },
];

export default function PartnerFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 100 });
  const { containerRef: faqRef, revealedCount: faqRevealed } = useScrollRevealGroup<HTMLDivElement>(faqItems.length);

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Вопросы и ответы
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Часто спрашивают о партнёрской программе
          </h2>
        </div>

        <div ref={faqRef} className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className={`rounded-xl border border-background-200/70 bg-background-100 overflow-hidden transition-all duration-200 reveal-fade-up ${i < faqRevealed ? 'revealed' : ''}`}
              style={i < faqRevealed ? { transitionDelay: `${i * 80}ms` } : undefined}
            >
              <button
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-display font-semibold text-[15px] md:text-[16px] text-foreground-950 pr-8">{item.q}</span>
                <div className={`w-6 h-6 rounded-full border border-background-300 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-45 bg-primary-100 border-primary-300' : ''}`}>
                  <i className={`ri-add-line text-sm ${openIndex === i ? 'text-primary-600' : 'text-foreground-400'}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-5 md:pb-6 px-5 md:px-6' : 'max-h-0'}`}
              >
                <p className="text-[14px] md:text-[15px] text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 md:mt-10 text-center">
          <p className="text-[14px] text-foreground-500 mb-3">
            Остались вопросы? Напишите нам — ответим лично.
          </p>
          <a
            href="https://t.me/anna_aigam"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[14px] font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer link-underline"
          >
            <i className="ri-telegram-line"></i>
            @anna_aigam
          </a>
        </div>
      </div>
    </section>
  );
}